import * as React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

import { Icon } from '../Icon';
import { Text } from '../Typography';

const { StyledTitle, StyledContent, StyledWrapper } = Styles;

export const Accordeon = ({ children, title, description }) => {
    const [toggle, setToggle] = React.useState(null);
    return (
        <StyledWrapper>
            <StyledTitle onClick={() => setToggle(!toggle)}>
                <div>
                    <Text large>{title}</Text>
                    <Text>{description}</Text>
                </div>
                <div>
                    {toggle ? (
                        <Icon icon={['far', 'chevron-down']} id="accordeon-open-feedback" />
                    ) : (
                        <Icon icon={['far', 'chevron-up']} id="accordeon-closed-feedback" />
                    )}
                </div>
            </StyledTitle>
            <StyledContent className={toggle ? 'open' : 'none'}>{children}</StyledContent>
        </StyledWrapper>
    );
};

Accordeon.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
};

Accordeon.defaultProps = {};

Accordeon.Styles = Styles;
